import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { ToolbarControlGroup } from '@kerfjs/ui/toolbar-control-group';
import { type SafeHtml } from 'kerfjs';
import { Paperclip } from 'lucide';

/** Attach files: a stock group button that opens the group's hidden file input
 *  (`attach-open` in init.ts), so the ToolbarControlGroup styles it as shipped
 *  (HS2-NHDJXB). */
export function AttachmentControl({ input }: { input: SafeHtml }): SafeHtml {
  return (
    <ToolbarControlGroup label="Attach" appearance="borderless">
      <button type="button" data-action="attach-open" aria-label="Attach Files">
        <LucideIcon icon={Paperclip} name="" />
      </button>
      {input}
    </ToolbarControlGroup>
  );
}
